module.exports = __webpack_public_path__ + "img/img_no_bdo.321fd9c4.png";